import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "@i18n";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { getFinancePostData } from "@/apis/freeFinance/getFinancePostData";
import ReservedPostException from "@/exceptions/postExceptions/ReservedPostException";
import createArib from "@/apis/aribApis/createArib";
import aribSendOtp from "@/apis/aribApis/aribSendOtp";
import verifyAribOtp from "@/apis/aribApis/verifyAribOtp";
import useLocalStorage from "@hooks/useLocalStorage";
import deleteFinanceOrder from "@/apis/freeFinance/deleteFinanceOrder";
import { useLang } from "@/common/Contexts/LanguageContext";
import arib_bank_list_ar from "../../../data/lookups/arib_bank_list_ar.json";
import arib_bank_list_en from "../../../data/lookups/arib_bank_list_en.json";
import arib_work_list_ar from "../../../data/lookups/arib_work_list_ar.json";
import arib_work_list_en from "../../../data/lookups/arib_work_list_en.json";
var extractAndValidationQueryParams = function extractAndValidationQueryParams() {
  var searchParams = new URLSearchParams(__IS_CSR__ ? window.location.search : "");
  var financestep = Number(searchParams.get("financestep")) || 1;
  var post_id = Number(searchParams.get("post_id"));
  var ref = searchParams.get("ref") === 'aribForm' ? 'aribForm' : null;
  return {
    post_id: post_id,
    financestep: financestep,
    ref: ref
  };
};
var AribFinanceContext = /*#__PURE__*/createContext(null);
export function useAribFinance() {
  return useContext(AribFinanceContext);
}

// @ts-ignore
export var AribFinanceContextProvider = function AribFinanceContextProvider(_ref) {
  var children = _ref.children;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t;
  var _useSession = useSession(),
    sessionUser = _useSession.user;
  var _useState = useState(null),
    fetching_error = _useState[0],
    setFetching_error = _useState[1];
  var _useState2 = useState(true),
    fetch_loading = _useState2[0],
    setFetch_loading = _useState2[1];
  var _useLocalStorage = useLocalStorage(),
    getLocalStorage = _useLocalStorage.getLocalStorage,
    setLocalStorage = _useLocalStorage.setLocalStorage,
    removeLocalStorage = _useLocalStorage.removeLocalStorage;
  var _useState3 = useState(null),
    postData = _useState3[0],
    setPostData = _useState3[1];
  var queryParams = extractAndValidationQueryParams();
  var _useState4 = useState(queryParams.financestep),
    highestStepReached = _useState4[0],
    setHighestStepReached = _useState4[1];
  var lang = useLang();
  var _useState5 = useState(function () {
      var defaultUserInfo = {
        whatsapp_optin: 1,
        first_name: null,
        fathers_name: null,
        family_name: null,
        birth_date: null,
        mobile_number: (sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.phone_number) || null,
        city_id: (sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.city_id) || null,
        gender: null,
        id_number: null
      };
      var stored = getLocalStorage("arib_userInfo");
      if (!stored) return defaultUserInfo;
      var parsedStored = JSON.parse(stored);

      // Create merged object with non-null values from storage
      return _objectSpread(_objectSpread({}, defaultUserInfo), Object.fromEntries(Object.entries(parsedStored).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          _ = _ref3[0],
          value = _ref3[1];
        return value !== null && value !== "";
      })));
    }),
    userInfo = _useState5[0],
    setUserInfo = _useState5[1];
  var _useState6 = useState(function () {
      var stored = getLocalStorage("arib_workInfo");
      return stored ? JSON.parse(stored) : {
        work_sector: null,
        salary: null,
        salary_transfer_method: null,
        employer_name: null
      };
    }),
    workInfo = _useState6[0],
    setWorkInfo = _useState6[1];
  var _useState7 = useState(function () {
      var stored = getLocalStorage("arib_orderData");
      return stored ? JSON.parse(stored) : {
        order_id: null,
        order_uuid: null,
        transaction_id: null,
        skipToUploadPage: null,
        reachAribOtpStep: false
      };
    }),
    orderData = _useState7[0],
    setOrderData = _useState7[1];

  /*********************/

  useEffect(function () {
    if (queryParams.financestep === 1 && highestStepReached == 7) {
      setUserInfo(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          id_number: null
        });
      });
      setHighestStepReached(queryParams.financestep);
    }
    //disable this area to make back work normal else if user try to return after any steps it navigates to post view
    // if(window.location.href.indexOf("financestep") === -1){
    //     return;
    // }
    // if (queryParams.financestep < highestStepReached && queryParams.financestep !== 5) {
    //     action__clearLocalStorageData()
    //     navigateTo("/cardetail/" + postData?.post_id + "?ref=error-multiple-actions");
    // } else
    if (queryParams.financestep > highestStepReached) {
      setHighestStepReached(queryParams.financestep);
    }
  }, [queryParams.financestep, highestStepReached]);
  useEffect(function () {
    if (queryParams.ref === 'aribForm') {
      history.replaceState(null, "", window.location.pathname + window.location.search.replaceAll("&ref=aribForm", '').replaceAll("ref=aribForm", ''));
      setUserInfo(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          mobile_number: (sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.phone_number) || null
        });
      });
    }
  }, [sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.phone_number]); // this will only trigger when userInfo changes on session

  // // Save userInfo
  useEffect(function () {
    setLocalStorage("arib_userInfo", JSON.stringify(userInfo));
  }, [userInfo]);

  // Save workInfo
  useEffect(function () {
    setLocalStorage("arib_workInfo", JSON.stringify(workInfo));
  }, [workInfo]);

  // Save orderData
  useEffect(function () {
    setLocalStorage("arib_orderData", JSON.stringify(orderData));
  }, [orderData]);
  var action__clearLocalStorageData = function action__clearLocalStorageData() {
    removeLocalStorage("arib_userInfo");
    removeLocalStorage("arib_workInfo");
    removeLocalStorage("arib_orderData");
  };
  var action__getPostID = function action__getPostID() {
    return (queryParams === null || queryParams === void 0 ? void 0 : queryParams.post_id) + "";
  };
  var action__getCurrentTitle = function action__getCurrentTitle() {
    if ((queryParams === null || queryParams === void 0 ? void 0 : queryParams.financestep) === 1) {
      return t("معلومات الشخصية", {
        ns: "web_checkout_finance"
      });
    } else if ((queryParams === null || queryParams === void 0 ? void 0 : queryParams.financestep) === 2) {
      return t("معلومات العمل", {
        ns: "web_checkout_finance"
      });
    } else if ((queryParams === null || queryParams === void 0 ? void 0 : queryParams.financestep) === 3) {
      return t("الوثائق المطلوبة", {
        ns: "web_checkout_finance"
      });
    }
    return ""; // Ensure it always returns a string
  };
  var action__getFinanceStep = function action__getFinanceStep() {
    return queryParams.financestep;
  };
  var action__updateUserInfo = function action__updateUserInfo(updates) {
    setUserInfo(function (prev) {
      return _objectSpread(_objectSpread({}, prev), updates);
    });
  };
  var action__updateWorkInfo = function action__updateWorkInfo(updates) {
    setWorkInfo(function (prev) {
      return _objectSpread(_objectSpread({}, prev), updates);
    });
  };
  var action__updateOrderInfo = function action__updateOrderInfo(updates) {
    setOrderData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), updates);
    });
  };
  var action__validateUserInfo = function action__validateUserInfo() {
    var requiredFields = ["first_name", "fathers_name", "family_name", "mobile_number", "city_id", "gender", "id_number", "birth_date"];
    var fieldErrorMessages = {
      first_name: t("الاسم الأول مطلوب", {
        ns: "web_checkout_finance"
      }),
      fathers_name: t("الاسم الثاني مطلوب", {
        ns: "web_checkout_finance"
      }),
      family_name: t("الاسم الأخير مطلوب", {
        ns: "web_checkout_finance"
      }),
      mobile_number: t("رقم الجوال مطلوب", {
        ns: "web_checkout_finance"
      }),
      city_id: t("المدينة مطلوبة", {
        ns: "web_checkout_finance"
      }),
      gender: t("الجنس مطلوب", {
        ns: "web_checkout_finance"
      }),
      id_number: t("رقم الهوية مطلوب", {
        ns: "web_checkout_finance"
      }),
      birth_date: t("تاريخ الميلاد مطلوب", {
        ns: "web_checkout_finance"
      }),
      // If you require whatsapp_optin:
      whatsapp_optin: t("خيار الواتساب مطلوب", {
        ns: "web_checkout_finance"
      })
    };
    var errors = {};
    for (var _i = 0, _requiredFields = requiredFields; _i < _requiredFields.length; _i++) {
      var field = _requiredFields[_i];
      if (!userInfo[field]) {
        errors[field] = fieldErrorMessages[field] || "Missing required field: ".concat(field);
      }
    }
    return errors; // empty object if no errors
  };
  var action__validateWorkInfo = function action__validateWorkInfo() {
    var requiredFields = ["work_sector", "salary", "salary_transfer_method"];
    var fieldErrorMessages = {
      work_sector: t("قطاع العمل مطلوب", {
        ns: "web_checkout_finance"
      }),
      salary: t("الراتب مطلوب", {
        ns: "web_checkout_finance"
      }),
      salary_transfer_method: t("طريقة تحويل الراتب مطلوبة", {
        ns: "web_checkout_finance"
      }),
      employer_name: t("الحقل مطلوب", {
        ns: "web_checkout_finance"
      })
    };
    var errors = {};
    for (var _i2 = 0, _requiredFields2 = requiredFields; _i2 < _requiredFields2.length; _i2++) {
      var field = _requiredFields2[_i2];
      if (!workInfo[field]) {
        errors[field] = fieldErrorMessages[field] || "Missing required field: ".concat(field);
      }
    }
    return errors; // empty object if no errors
  };
  var fetch__FinancePostData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            try {
              getFinancePostData(queryParams === null || queryParams === void 0 ? void 0 : queryParams.post_id).then(function (res) {
                var _res$data;
                var _ref5 = (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || {},
                  details = _ref5.details,
                  price = _ref5.price,
                  g4Data = _ref5.g4Data;
                // Extract what you need

                var _ref6 = details || {},
                  title = _ref6.h1;
                var _ref7 = price || {},
                  finance_price = _ref7.finance_price;
                var _ref8 = g4Data || {},
                  post_condition = _ref8.post_condition;
                var _ref9 = details || {},
                  have_finance = _ref9.have_finance;
                var post_ID = queryParams === null || queryParams === void 0 ? void 0 : queryParams.post_id;

                // Then store exactly what you want:
                setPostData({
                  title: title,
                  finance_price: finance_price,
                  post_condition: post_condition,
                  g4Data: g4Data,
                  have_finance: have_finance,
                  post_id: post_ID
                });
              });
            } catch (error) {
              if (error instanceof ReservedPostException) {
                //return navigateTo(`/cardetail/${error.post_id}?ref=car_reserved`);
              }
              setFetching_error(error);
            } finally {
              setFetch_loading(false);
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetch__FinancePostData() {
      return _ref4.apply(this, arguments);
    };
  }();
  var fetch__WorkSectorList = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", lang == 'ar' ? arib_work_list_ar : arib_work_list_en);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function fetch__WorkSectorList() {
      return _ref10.apply(this, arguments);
    };
  }();
  var fetch__BanksList = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", lang == 'ar' ? arib_bank_list_ar : arib_bank_list_en);
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function fetch__BanksList() {
      return _ref11.apply(this, arguments);
    };
  }();
  var fetch__CreateArib = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var params;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            setFetch_loading(true);
            params = {
              postId: queryParams === null || queryParams === void 0 ? void 0 : queryParams.post_id,
              userInfo: userInfo,
              workInfo: workInfo
            };
            return _context4.abrupt("return", createArib(params.postId, params.userInfo, params.workInfo).then(function (res) {
              var data = (res === null || res === void 0 ? void 0 : res.data) || null;
              return data;
            })["catch"](function (error) {
              setFetching_error(error);
              return null;
            })["finally"](function () {
              setFetch_loading(false);
            }));
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function fetch__CreateArib() {
      return _ref12.apply(this, arguments);
    };
  }();
  var fetch__AribSendOtop = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var params;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            setFetch_loading(true);
            params = {
              order_uuid: orderData === null || orderData === void 0 ? void 0 : orderData.order_uuid
            };
            return _context5.abrupt("return", aribSendOtp(params.order_uuid).then(function (res) {
              var data = (res === null || res === void 0 ? void 0 : res.data) || null;
              return data;
            })["catch"](function (error) {
              setFetching_error(error);
              return null;
            })["finally"](function () {
              setFetch_loading(false);
            }));
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function fetch__AribSendOtop() {
      return _ref13.apply(this, arguments);
    };
  }();
  var fetch__VerifyAribOtp = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(code) {
      var params;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            setFetch_loading(true);
            params = {
              transaction_id: orderData === null || orderData === void 0 ? void 0 : orderData.transaction_id,
              order_uuid: orderData === null || orderData === void 0 ? void 0 : orderData.order_uuid,
              otp: code
            };
            return _context6.abrupt("return", verifyAribOtp(params.transaction_id, params.order_uuid, params.otp).then(function (res) {
              var data = (res === null || res === void 0 ? void 0 : res.data) || null;
              return data;
            })["catch"](function (error) {
              setFetching_error(error);
              return null;
            })["finally"](function () {
              setFetch_loading(false);
            }));
          case 3:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function fetch__VerifyAribOtp(_x) {
      return _ref14.apply(this, arguments);
    };
  }();
  var fetch__deleteFinanceOrder = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(order_uuid) {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", deleteFinanceOrder({
              order_uuid: order_uuid
            }));
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function fetch__deleteFinanceOrder(_x2) {
      return _ref15.apply(this, arguments);
    };
  }();

  /** Collections **/
  var actions = {
    action__getPostID: action__getPostID,
    action__getCurrentTitle: action__getCurrentTitle,
    action__getFinanceStep: action__getFinanceStep,
    action__updateUserInfo: action__updateUserInfo,
    action__updateWorkInfo: action__updateWorkInfo,
    action__updateOrderInfo: action__updateOrderInfo,
    action__validateUserInfo: action__validateUserInfo,
    action__validateWorkInfo: action__validateWorkInfo,
    action__clearLocalStorageData: action__clearLocalStorageData
  };
  var remote_actions = {
    fetch__FinancePostData: fetch__FinancePostData,
    fetch__WorkSectorList: fetch__WorkSectorList,
    fetch__BanksList: fetch__BanksList,
    fetch__CreateArib: fetch__CreateArib,
    fetch__AribSendOtop: fetch__AribSendOtop,
    fetch__VerifyAribOtp: fetch__VerifyAribOtp,
    fetch__deleteFinanceOrder: fetch__deleteFinanceOrder
  };
  var state = {
    userInfo: userInfo,
    workInfo: workInfo,
    fetching_error: fetching_error,
    fetch_loading: fetch_loading,
    postData: postData,
    orderData: orderData
  };
  return /*#__PURE__*/React.createElement(AribFinanceContext.Provider, {
    value: {
      actions: actions,
      remote_actions: remote_actions,
      state: state,
      queryParams: queryParams
    }
  }, children);
};